import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "participate-content-in-dialog" }
const _hoisted_2 = {
  key: 0,
  class: "dialog-content"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-color-primary" }, "4 zero-waste", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" boxes will be sent to group participants! Please write the name of the group correctly. ")
const _hoisted_5 = { class: "dialog-btn-group len-2" }
const _hoisted_6 = {
  key: 1,
  class: "dialog-content"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "font-color-primary" }, "2 zero-waste", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" boxes will be sent to individual participants! ")
const _hoisted_9 = { class: "dialog-btn-group len-2" }
const _hoisted_10 = {
  key: 2,
  class: "dialog-content"
}
const _hoisted_11 = { class: "option-group" }
const _hoisted_12 = { class: "dialog-desc" }
const _hoisted_13 = { class: "option-group" }
const _hoisted_14 = { class: "dialog-desc" }

import { ColorVariants, PEOPLE_COLLECTION } from '@/constants';
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  // 有可能是modal.ts 的实例弹出来的，需要这个组件
  import AppLoadingButton from '@/components/loading-button.vue';

  interface IProps {
    peopleCollection: PEOPLE_COLLECTION;
    onSelectPeopleCollection: (peopleCollection: PEOPLE_COLLECTION) => void;
    onConfirm: (groupName: string | undefined) => void;
    onCanel: () => void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    peopleCollection: null,
    onSelectPeopleCollection: null,
    onConfirm: null,
    onCanel: null
  },
  setup(__props: any) {

const props = __props as {
    peopleCollection: PEOPLE_COLLECTION;
    onSelectPeopleCollection: (peopleCollection: PEOPLE_COLLECTION) => void;
    onConfirm: (groupName: string | undefined) => void;
    onCanel: () => void;
  }

  const { t } = useI18n();
  
  const groupName = ref('');
  const handleSelect = (peopleCollection: PEOPLE_COLLECTION) => props.onSelectPeopleCollection(peopleCollection);
  const handleInputConfirm = () => props.onConfirm(groupName.value);
  const handleConfirm = () => props.onConfirm(undefined);
  const handleCancel = () => props.onCanel();


return (_ctx: any,_cache: any) => {
  const _component_b_form_input = _resolveComponent("b-form-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.peopleCollection === _unref(PEOPLE_COLLECTION).group)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_b_form_input, {
            modelValue: groupName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((groupName).value = $event)),
            class: "input",
            required: "",
            type: "text"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(AppLoadingButton, {
              class: "btn",
              pill: "",
              variant: _unref(ColorVariants).outlinePrimary,
              onClick: handleCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('Close')), 1)
              ]),
              _: 1
            }, 8, ["variant"]),
            _createVNode(AppLoadingButton, {
              class: "btn",
              pill: "",
              variant: _unref(ColorVariants).primary,
              disabled: !groupName.value,
              onClick: handleInputConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('Apply')), 1)
              ]),
              _: 1
            }, 8, ["variant", "disabled"])
          ])
        ]))
      : (__props.peopleCollection === _unref(PEOPLE_COLLECTION).individual)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(AppLoadingButton, {
                class: "btn",
                pill: "",
                variant: _unref(ColorVariants).outlinePrimary,
                onClick: handleCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Close')), 1)
                ]),
                _: 1
              }, 8, ["variant"]),
              _createVNode(AppLoadingButton, {
                class: "btn",
                pill: "",
                variant: _unref(ColorVariants).primary,
                onClick: handleConfirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Apply')), 1)
                ]),
                _: 1
              }, 8, ["variant"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('individual_desc')), 1),
              _createVNode(AppLoadingButton, {
                class: "btn",
                pill: "",
                variant: _unref(ColorVariants).primary,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSelect(_unref(PEOPLE_COLLECTION).individual)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('individual_btn')), 1)
                ]),
                _: 1
              }, 8, ["variant"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('group_desc')), 1),
              _createVNode(AppLoadingButton, {
                class: "btn",
                pill: "",
                variant: _unref(ColorVariants).primary,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSelect(_unref(PEOPLE_COLLECTION).group)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('group_btn')), 1)
                ]),
                _: 1
              }, 8, ["variant"])
            ])
          ]))
  ]))
}
}

})